// removed by extract-text-webpack-plugin
module.exports = {"playWrapper":"_2swD2rQ72OFNY9WTctGS-e","title":"_3tgHZx-cyULeKjVBHGz3IV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoPlayer/VideoPlayer.mod.css
// module id = 1043
// module chunks = 0